'use client';

import {
    Box,
    BoxContent,
    BoxHeader,
    Columns,
    ColumnsItem,
    Headline,
    HeadlineLevel,
    HeadlineMarkup,
    Image,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
    TypographyAlign,
    View,
} from '@bytel/trilogy-react-ts';

import { FaiProduct, RangesNewGeneration } from '@app-types/fai';
import { JOURNEYS } from '@app-types/product';

import { useHome } from '@landing/hooks';

import { CtaAddToCart } from '../cta-add-to-cart';
import { BBoxDetail } from './b-box-detail';

interface BboxCardProps {
    selectedOffer?: FaiProduct | null;
    onClickDetails: (offerRange: RangesNewGeneration) => void;
}

export default function BboxCard({ selectedOffer, onClickDetails }: Readonly<BboxCardProps>) {
    const {
        setSelectedFaiOption,
        selectedFaiProduct,
        temporarilySelectedFaiProduct,
        setSelectedFaiProduct,
        otisConfigurator,
    } = useHome();
    const isFaiFirst = otisConfigurator.value === JOURNEYS.FAI;
    const offerTitle = selectedOffer?.title?.replace('Pure fibre', 'Pure fibre');

    return (
        <Box shadowless className='is-bordered fai-details-container'>
            {selectedOffer?.hat && (
                <BoxHeader className='is-justified-center has-byou-background'>
                    <Text level={TextLevels.ONE} marginless typo={TypographyAlign.TEXT_CENTERED}>
                        {selectedOffer.hat}
                    </Text>
                </BoxHeader>
            )}
            <BoxContent
                className={
                    !temporarilySelectedFaiProduct ||
                    temporarilySelectedFaiProduct?.gencode_offre === selectedFaiProduct?.gencode_offre
                        ? 'border-2x'
                        : ''
                }
            >
                <Columns mobile marginless className='is-aligned-end'>
                    <ColumnsItem className='pl-0 pr-0 pt-0'>
                        <Headline
                            markup={HeadlineMarkup.H3}
                            className='has-text-blue-byou'
                            level={HeadlineLevel.LEVEL4}
                        >
                            {offerTitle}
                        </Headline>
                        <Text>{selectedOffer?.subtitle}</Text>
                    </ColumnsItem>
                    <ColumnsItem narrow className='pl-0 pr-0 pt-0'>
                        {selectedOffer?.image_url ? <Image src={selectedOffer?.image_url} width={90} alt='' /> : null}
                    </ColumnsItem>
                </Columns>
                <Spacer size={SpacerSize.MEDIUM} />
                <BBoxDetail selectedFaiProduct={selectedOffer} />
                <Spacer size={SpacerSize.MEDIUM} />
                {!isFaiFirst && (
                    <CtaAddToCart
                        selectedProduct={selectedFaiProduct}
                        temporarilySelectedProduct={temporarilySelectedFaiProduct}
                        handleAddToCart={() => {
                            if (selectedFaiProduct?.gencode_offre !== temporarilySelectedFaiProduct?.gencode_offre) {
                                setSelectedFaiProduct(temporarilySelectedFaiProduct || null);
                            } else {
                                setSelectedFaiProduct(null);
                                setSelectedFaiOption('');
                            }
                        }}
                        ctaLabel={{
                            productAdded: 'Retirer cette box',
                            productNotAdded: 'Ajouter cette box',
                            tagAdded: 'Bbox ajoutée',
                        }}
                    />
                )}
                <Box shadowless className='is-marginless'>
                    <View flexable className='is-centered'>
                        <a
                            data-testid='btn_see_details'
                            className='link button-clear has-text-blue-byou is-paddingless see-more-details has-text-centered'
                            onClick={() => onClickDetails(selectedOffer!.range_ng)}
                        >
                            Voir les détails de l&apos;offre
                        </a>
                    </View>
                </Box>
            </BoxContent>
        </Box>
    );
}
